import React from "react";
import Icon from "../atoms/Icon";
import Select from "react-dropdown-select";

const ViaqSelectBox = ({
                           iconName,
                           label,
                           placeholder,
                           values,
                           onChange,
                           disabled = false,
                           id,
                           width = "w-full",
                           loading = false,
                           defaultValue,
                           searchFunction,
                           className = "",
                           showIcon = true,
                       }) => {

    const selectValue = defaultValue ? [{label: defaultValue, value: defaultValue}] : [];

    const customNoDataRenderer = () => {
        return <div style={{display: "none"}}></div>;
    };

    return (
        <div className={`flex flex-col ${className}`}>
            {label && (
                <label htmlFor={id} className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
                    {label}
                </label>
            )}

            <div className="flex flex-row bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm">
                {showIcon && <Icon iconName={iconName}/>}

                <div className="w-full">
                    <Select
                        noDataLabel="داده ای یافت نشد"
                        onChange={disabled ? () => {} : onChange}
                        options={values}
                        placeholder={disabled ? "" : placeholder}
                        direction="rtl"
                        style={{
                            // width: width,
                            minWidth: "210px",
                            maxWidth: "300px",
                            border: "none",

                            height: "54px ",
                            fontSize: "14px ",
                            paddingRight: "0px",
                            paddingLeft: "25px",
                            marginRight: "5px",
                            color: "#374170",
                            alignItems: "center",
                        }}

                        values={selectValue}
                        searchFn={(props, state, methods) => {
                            if (searchFunction && !disabled) {
                                searchFunction(props);
                            }
                        }}
                        disabled={disabled}
                        searchable={!disabled}
                        clearable={false}
                        multi={false}
                        closeOnSelect={true}

                        loading={loading}
                        noDataRenderer={customNoDataRenderer}

                        dropdownHandleRenderer={({state}) => (
                            <span>
                                <Icon className="w-3 h-3" iconName="arrow-down"/>
                            </span>
                        )}

                        dropdownPosition="bottom"
                    />
                </div>
            </div>
        </div>
    );
};

export default ViaqSelectBox;